import React from 'react';
import {ReactComponent as Btn1} from '../../../Assets/Icons/phone1.svg';
import Bg from '../../../Assets/Backgrounds/appBanner.webp';
import AppsBanner from '../../Shared/AppsBanner/AppsBanner';
const Banner=()=>{
    return(
        <>
        <AppsBanner
        title="Securely manage your files and collaborate with everyone from anywhere."
        backgroundImage = {Bg}
        btn1={<Btn1 />}
        />
        </>
    )
};
export default Banner ;